import {Component, OnInit} from '@angular/core';
import {NewsService} from '../../../../services/news.service';
import {Observable} from 'rxjs';
import {News} from '../../../../model/News';
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {CommonModule} from "@angular/common";
import {SpinnerComponent} from "../../../common/spinner/spinner.component";

@Component({
    selector: 'app-dash-block-news',
    templateUrl: './dash-block-news.component.html',
    imports: [
        CommonModule,
        FaIconComponent,
        SpinnerComponent,
    ],
    styleUrls: ['./dash-block-news.component.css']
})
export class DashBlockNewsComponent implements OnInit {

  news: Observable<News[]>;

  constructor(private newsService: NewsService) {
  }

  ngOnInit(): void {
    this.news = this.newsService.getLatestNews();
  }

  followNewsLink(link): void {
    window.open(link, '_blank');
  }

}
